import request from "@/utils/request";
import store from "@/store";
import {
  projectDetailAndroid,
  getProjectConfig,
  getAndroidConstructType,
  androidconfigEdit,
  androidearthquakeCategory,
  isAndroidOnline,
} from "@/api/androidApi";

// 抗震烈度查询
export function earthquakeCategory(data) {
  if (store.state.app.isAndroid) {
    return androidearthquakeCategory(id);
  }
  return request({
    url: "/api/v1/earthquakeCategory",
    method: "get",
    params: {
      ...data,
    },
  });
}

// 项目状态禁用启用
export function projectStatus(data) {
  return request({
    url: "/api/v1/projectStatus",
    method: "post",
    data,
  });
}

// 项目列表
export function projectList(data) {
  return request({
    url: "/api/v1/projectList",
    method: "get",
    params: {
      ...data,
    },
  });
}

// 所有项目列表
export function projectAllList() {
  return request({
    url: "/api/v1/projectAllList",
    method: "get",
  });
}

// 项目详情
export function projectDetail(id) {
  if (store.state.app.isAndroid) {
    return projectDetailAndroid(id);
  }
  return request({
    url: "/api/v1/projectDetail",
    method: "get",
    params: {
      project_id: id,
    },
  });
}

// 删除项目
export function projectDeleted(data) {
  return request({
    url: "/api/v1/projectDeleted",
    method: "delete",
    data,
  });
}

// 添加项目
export function projectAdd(data) {
  return request({
    url: "/api/v1/projectAdd",
    method: "post",
    data,
  });
}

// 项目编辑
export function projectUpdate(data) {
  return request({
    url: "/api/v1/projectUpdate",
    method: "post",
    data,
  });
}

// 行业动态
export function articleList(data) {
  return request({
    url: "/api/v1/articleList",
    method: "get",
    params: {
      ...data,
    },
  });
}

// 我参与的项目
export function myProjectList(data) {
  return request({
    url: "/api/v1/myProjectList",
    method: "get",
    params: {
      ...data,
    },
  });
}

// 测试与安卓联调封装
export function TestAndroid(data) {
  return request(
    {
      url: "/api/v1/myProjectList",
      method: "get",
      params: {
        ...data,
      },
    }, // 网络请求参数
    true, // 是否区分安卓设备
    "setUserInfo" // 安卓接口对象和方法名
  );
}

// 获取项目配置参数
export function projectConfig(data) {
  if (isAndroidOnline()) {
    return getProjectConfig(data);
  }
  return request({
    url: "/api/v1/project/configInfo",
    method: "get",
    params: {
      ...data,
    },
  });
}

// 设置项目配置参数
export function configEdit(data) {
  if (isAndroidOnline()) {
    return androidconfigEdit(data);
  }
  return request({
    url: "/api/v1/project/configEdit",
    method: "post",
    data,
  });
}

// 获取构件类型
export function getConstructType() {
  // console.log("getConstructType");
  if (store.state.app.isAndroid) {
    return getAndroidConstructType();
  }
  return request({
    url: "/api/v1/oyc/pro/constructtype.html",
    method: "post",
  });
}

export function wunlock(params) {
  return request({
    url: "/api/v1/oyc/pro/wunlock.html",
    method: "get",
    params,
  });
}

export function wunlockapply(params) {
  return request({
    url: "/api/v1/oyc/pro/wunlockapply.html",
    method: "get",
    params,
  });
}

export function agree(params) {
  return request({
    url: "/api/v1/oyc/pro/agree.html",
    method: "get",
    params,
  });
}

export function refuse(params) {
  return request({
    url: "/api/v1/oyc/pro/refuse.html",
    method: "get",
    params,
  });
}

export function setLockTime(params) {
  return request({
    url: "/api/v1/oyc/pro/setLockTime.html",
    method: "get",
    params,
  });
}

export function setBottomConfig(data) {
  return request({
    url: "/api/v1/setBottomConfig",
    method: "post",
    data,
  });
}

export function getBottomConfig(params) {
  return request({
    url: "/api/v1/getBottomConfig",
    method: "get",
    params,
  });
}
